import React, { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import classNames from "classnames";
import { xor } from "lodash";
import styles from "./MultiSelect.module.scss";
import { Check, ChevronDown } from "lucide-react";

function MultiSelect({
  label,
  options,
  onChangeSelectedValues,
  selectedValues,
  disabled,
  className,
}) {
  const [multiSelectActive, setMultiSelectActive] = useState(false);

  const handleCloseMultiSelect = () => {
    setMultiSelectActive(false);
  };

  return (
    <div className={styles.wrapper}>
      <div
        className={classNames(
          styles.button,
          disabled && styles.disabled,
          className,
        )}
        onMouseDown={() =>
          !disabled && setMultiSelectActive(!multiSelectActive)
        }
        role="button"
        tabIndex={disabled ? -1 : 0}
        aria-haspopup="listbox"
        aria-expanded={multiSelectActive}
        onKeyDown={(e) => {
          if (disabled) return;
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setMultiSelectActive(!multiSelectActive);
            return;
          }
          if (e.key === "Escape") {
            setMultiSelectActive(false);
          }
        }}
      >
        <span className={styles.label}>{label}</span>
        <ChevronDown
          className={classNames(styles.icon, {
            [styles.iconOpen]: multiSelectActive,
          })}
          size={16}
        />
      </div>
      <OutsideClickHandler
        onOutsideClick={handleCloseMultiSelect}
        disabled={!multiSelectActive}
      >
        {multiSelectActive && options && (
          <div className={styles.options}>
            {options.map((option) => {
              const isSelected = selectedValues.includes(option.id);

              return (
                <div
                  key={option.id}
                  className={classNames(styles.option, {
                    [styles.selected]: isSelected,
                  })}
                  onClick={() => {
                    onChangeSelectedValues(xor(selectedValues, [option.id]));
                  }}
                  onKeyDown={() => {
                    onChangeSelectedValues(xor(selectedValues, [option.id]));
                  }}
                >
                  <div className={styles.checkbox}>
                    {isSelected && (
                      <Check className={styles.checkIcon} size={16} />
                    )}
                  </div>
                  <span
                    className={classNames(styles.optionLabel, {
                      [styles.selected]: isSelected,
                    })}
                  >
                    {option.label}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </OutsideClickHandler>
    </div>
  );
}

export default MultiSelect;
